module.exports = __webpack_public_path__ + "img/index-section6-friend10.43a5f4aa.svg";